import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ShareProjectUserInput } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface ShareProjectUserMutationInput {
  projectId: number;
  input: ShareProjectUserInput;
}

/**
 * Mutation hook for granting a single user direct access to a project (Owner/Admin only).
 * Calls POST /projects/:id/share/user.
 * Invalidates the project detail so share arrays refresh.
 */
export function useShareProjectUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ projectId, input }: ShareProjectUserMutationInput) => {
      await apiClient.post(`/projects/${projectId}/share/user`, input);
    },
    onSuccess: (_data, { projectId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.projects.byId(projectId) });
    },
  });
}
